export const REFERENCE_IMAGE_ELEMENT_ID = 'reference-image-id' as const;

export const REFERENCE_IMAGE_CANVAS_ELEMENT_NAME = 'reference-image' as const;

export const VALID_REFERENCE_FILE_TYPES = [
  'image/png',
  'image/jpg',
  'image/jpeg',
  'image/webp',
] as const;

export const REFERENCE_POINT_A_ELEMENT_ID = 'reference-point-a-id' as const;
export const REFERENCE_POINT_B_ELEMENT_ID = 'reference-point-b-id' as const;
export const REFERENCE_LINE_ELEMENT_ID = 'reference-line-id' as const;

/**
 * @desciption gap between the image and the x and y axis upon first uploading the image
 */
export const INITIAL_GAP_TO_AXIS_IN_MM = 1000;

export const REFERENCE_OPACITY_DEFAULT = 100;
export const REFERENCE_CANVAS_OPACITY_TO_OPACITY_PERCENT_FACTOR = 100;

export const REFERENCE_SCALE_MINIMUM_DISTANCE = 1;
export const REFERENCE_SCALE_ELEMENT_STROKE_WIDTH = 20;

export const REFERENCE_IMAGE_WARNING_SIZE_BYTES = 1300000;
export const REFERENCE_IMAGE_UPLOAD_MAX_SIZE_BYTES = 50 * 1024 * 1024;

export const REFERENCE_SCALING_ELEMENTS_COLOR_HEX = '#f00';
